const restrictedOperations = ['AddUserInteraction', 'signIn', 'signUp']

const isRestrictedOperation = (operationName: string) => {
  if (!operationName || typeof operationName !== 'string') {
    return false
  }

  return restrictedOperations.some(
    (op: string) => op.toLowerCase() === operationName.toLowerCase()
  )
}
export default isRestrictedOperation
